import { useState } from 'react';
import { HelpCircle } from 'lucide-react';

export default function Tooltip({ texto, exemplo }) {
  const [visivel, setVisivel] = useState(false);

  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: '6px' }}>
      <HelpCircle
        size={14}
        color="#aaa"
        style={{ cursor: 'pointer', flexShrink: 0 }}
        onMouseEnter={() => setVisivel(true)}
        onMouseLeave={() => setVisivel(false)}
      />
      {visivel && (
        <div style={{
          position: 'absolute', left: '20px', top: '-8px', zIndex: 100,
          background: '#13305f', color: '#fff', borderRadius: '8px',
          padding: '10px 14px', width: '240px', fontSize: '12px',
          lineHeight: '1.6', boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
        }}>
          <div>{texto}</div>
          {exemplo && (
            <div style={{ marginTop: '6px', color: '#94a3b8', fontSize: '11px' }}>
              💡 Ex: {exemplo}
            </div>
          )}
          <div style={{
            position: 'absolute', left: '-6px', top: '14px',
            width: '0', height: '0',
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderRight: '6px solid #13305f'
          }} />
        </div>
      )}
    </span>
  );
}